import { GetServerSideProps } from 'next'
import React from 'react'
import { withPublic } from '../src/component'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { LoginPage as Login } from '../src/page'

import { createCombinedServerSideProps } from '../src/utils/server/page-props'

const I18N_NAMESPACE = ['common', 'terminalError', 'login', 'password', 'verify', 'signUp', 'consumerLending']

const LoginPage: CheckoutPage = (props) => <Login {...props} />

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)

const LoginPagePublic: CheckoutPage = withPublic(LoginPage)
LoginPagePublic.getLayout = getLayout()

export default LoginPagePublic
